export default {
  account_id_required: "Account ID is required.",
  account_not_exists: "username မှားယွင်းနေသည် .",
  accountIdRequired: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  agent_comm_rate_required: "Agent commission rate is required.",
  agent_id_required: "Agent ID is required.",
  alphaNumOnly: "ဂဏာန်းနှင့် စာသားသာ အသုံးပြုရန် ",
  atLeastThreeMatchToBetParlay: "At least mix three matches to bet in parlay.",
  atLeastTwoMatchToBetParlay: "မောင်းကစားနည်းအား အနည်းဆုံး ၂ ပွဲ ကစားရန်.",
  bet_amount_required: "Bet amount is required.",
  bet_id_required: "Bet ID is required.",
  betAmountRequired: "လောင်း‌ကြေးအား ရွေးချယ်ပါ.",
  betExists: "Bet already exists.",
  betLowerMin: "သတ်မှတ်လောင်း‌ကြေးထက် လျော့နည်းနေသည်.",
  betNotExists: "ပြိုင်ပွဲသို့ ဝင်ရောက်ရန် မှန်ကန်သော ဗန်းကို ထားပါ။",
  betOverMax: "သတ်မှတ်လောင်း‌ကြေးထက် ကျော်လွန်နေသည်.",
  betOverMaxBet: "သတ်မှတ်လောင်းကြေးထက်ကျော်လွန်နေသည်.",
  betOverMaxPerMatch: "သတ်မှတ်လောင်း‌ကြေးထက် ကျော်လွန်နေသည်.",
  betTypeRequired: "ကစားနည်းအား ရွေးချယ်ပါ.",
  BLOCK: "အကောင့်ပိတ်ထားသည်",
  changeStakeMax: "MAX ကန့်သတ်ချက်ကြောင့် ထည့်သွင်းသော stake ငွေပမာဏ ပြောင်းလဲသွားပါသည်။",
  changeStakeMin: "MIN ကန့်သတ်ချက်ကြောင့် ထည့်သွင်းသော stake ငွေပမာဏ ပြောင်းလဲသွားပါသည်။",
  CLOSE: "အကောင့်ပိတ်ထားသည်",
  close: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  confirmNewPasswordRequired: "စကားဝှက်အသစ်အား အတည်ပြုပါ!",
  connectionFailed: "Failed to link wallet system.",
  containAlphaNum: "{fname} အနည်းဆုံး စာသားတစ်ခုနှင့် ဂဏာန်းတစ်ခု ရှိရမည် .",
  "createRoomFailed-1": "Create room failed 1.",
  "createRoomFailed-2": "Create room failed 2.",
  "createRoomFailed-3": "Create room failed 3.",
  credit_amount_required: "Credit amount is required.",
  currency_required: "Currency is required.",
  currencyNotSupported: "မတူညီသော ငွေကြေးကြောင့် လက်မခံပါ",
  currPasswordRequired: "လက်ရှိစကားဝှက်!",
  dataError: "Data Error",
  debit_amount_required: "Debit amount is required.",
  duplicate_credit_record: "Duplicate credit record.",
  duplicate_debit_record: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  endDateRequired: "ပြီးဆုံးမည့် ရက်စွဲ ထည့်သွင်းပါ!",
  EsportsDisabled: "E-Sports Game Disabled",
  forbiddenAccess: "ဝင်ရောက်ခြင်းအား ပိတ်ထားသည်",
  FREEZE: "အကောင့်အား ခေတ္တပိတ်ထားသည်",
  freeze: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  game_maintenance: "ကစားပွဲ ပြုပြင်နေသည်.",
  incompletedRequest: "တခုခု မှားယွင်းနေသည် ...",
  insufficient_balance: "ငွေမလောက်ပါ",
  invalid_password: "စကားဝှက် မှားယွင်းနေသည် ",
  invalidBetAmount: "လောင်းကြေးငွေပမာဏ မှားယွင်းနေသည်.",
  invalidBets: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  invalidCurrency: "ငွေမလောက်ပါ.",
  invalidleague: "Invalid league.",
  invalidMarketType: "Invalid market type provided.",
  invalidMatch: "Invalid match.",
  invalidMember: "Invalid member.",
  invalidOddsBall: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidOperator: "Invalid operator.",
  invalidPassword: "Invalid Password",
  invalidRoom: "Invalid room.",
  invalidRoomLimit: "Invalid room limit.",
  invalidRoomPassword: "Invalid PIN Code. PIN code must be 6 digit numbers.",
  invalidRoomRate: "Invalid room rate.",
  invalidRoomType: "Invalid room type.",
  invalidRTSMatchOdds: "မမှန်ကန်သော RTS Match Odds ဖြစ်ပါသည်။",
  invalidSession: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  IPJoinedBefore: "IP joined before.",
  isAlpha: "{fname} အား အင်္ဂလိပ်စာသားသာ အသုံးပြုရန် .",
  isAlphaNum: "{fname} အား အင်္ဂလိပ်ဂဏာန်းသာ အသုံးပြုရန် .",
  isEmail: "{fname} - email လိပ်စာ အသုံးပြုရန် .",
  isIpAddress: "{fname} IPv4 လိပ်စာ အသုံးပြုရန် .",
  isMaxLength: "{fname} အများဆုံးစာသား {fvalue}.",
  isMaxValue: "{fname} အများဆုံး {fvalue}.",
  isMinLength: "{fname} အနည်းဆုံးစာသား {fvalue}.",
  isMinValue: "{fname} အနည်းဆုံး {fvalue}.",
  isNumeric: "{fname} အား ဂဏာန်းသာ အသုံးပြုရန် .",
  isOutrightRequired: "Is Outright ထည့်သွင်းရန်!",
  // vuelidate
  isRequired: "{fname} အားဖြည့်ပါ.",
  isSameAs: "{fname} နှင့်  {fname2} ဆင်တူရမည် .",
  isUrl: "{fname} URLs သာ အသုံးပြုရန် .",
  "joinFailed-1": "Join room failed 1.",
  "joinFailed-2": "Join room failed 2.",
  leagueIdRequired: "League ID ထည့်သွင်းရန်!",
  liveCasinoDisabled: "Live Casino ပိတ်ထားသည်",
  liveMatchNotAllowed: "Live match not allowed.",
  //tournament
  login_id_not_exists: "Invalid login, please try to login again.",
  loginFailed: "ဝင်ရောက်၍ မရပါ ၊ ပြန်လည်ကြိုးစားပါ ...",
  loginLimit: "Login ဝင်ရောက်ခြင်း အကြိမ်များနေပါသည် ။ နောက်တစ်မိနစ်ကြာမှ ပြန်လည်ဝင်ရောက်ပါ ",
  lotteryDisabled: "Lottery ပိတ်ထားသည်",
  marketTypeChanged: "Bet Slip has been removed due to market type changed.<br />Please select again from the market.",
  marketTypeRequired: "Market Type is required.",
  master_comm_rate_required: "Master commission rate is required.",
  master_id_required: "Master ID is required.",
  matchDateRequired: "Match date is required.",
  matchHide: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားပွဲကို ရွေးချယ်ပါ",
  matchLowerMin: "Match lower min error occured.",
  matchNotActive: "This match is not available, please try match markets.",
  matchNotAllowBet: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  matchOverMax: "Match over max error occured.",
  matchRequired: "Match is required.",
  maxMatch: "Maximum {max} matches selected!",
  maxParlayTicket: "မောင်းကစားနည်း၏ အမြင့်ဆုံး ပွဲသတ်မှတ်ချက် ရောက်ရှိနေသည်!",
  maxRoomLimit: "No. of Players must be equal or less than 30.",
  maxRoomRate: "Entry fee must be equal or less than 1000.",
  member_id_required: "Member ID is required.",
  member_wallet_not_exists: "Member wallet not exists.",
  memberExists: "Member already exist.",
  memberJoinedBefore: "You have already joined before, please take note that public free room only can join once.",
  minBetAmount: "Minimum bet amount error occured.",
  MiniGameDisabled: "Mini Game Disabled",
  minMatch: "Minimum 3 matches selected.",
  minRoomLimit: "No. of Players must be equal or more than 3.",
  minRoomRate: "Entry fee must be equal or more than 10.",
  new_login_id_exists: "အမည်မှားယွင်းနေသည် ၊ အခြားအမည်ဖြင့် အသုံးပြုပါ",
  newPasswordRequired: "စကားဝှက်အသစ်!",
  nickNameRequired: "Nick Name အားထည့်သွင်းပါ!",
  noMatchSelected: "Please select at least 1 match.",
  notSameAs: "{fname} နှင့် {fname2} မတူရပါ.",
  NoUserAccessRight: "ခွင့်ပြုထားခြင်းမရှိပါ သင်၏ အေးဂျင့်အား ဆက်သွယ်ပါ...",
  oddsDisplayInvalid: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  oddsIsUpdating: "စျေးပြင်ဆင်နေသည် ...",
  OK: "အိုကေ",
  pageNumberRequired: "Page Number ထည့်သွင်းရန်!",
  pageSizeRequired: "Page Size ထည့်သွင်းရန်!",
  passwordRequired: "စကားဝှက်အား ထည့်ရန်",
  passwordsNotMatch: "စကားဝှက်မှားယွင်းနေပါသည်!",
  permission_denied: "Permission denied.",
  pointsOverLimit: "Points over limit error occured.",
  rate_required: "Rate is required.",
  rateLowerMin: "Rate lower min error occured.",
  rateOverMax: "Rate over max error occured.",
  requestFailed: "တောင်းဆိုမှု မအောင်မြင်ပါ ၊ သင်၏ အင်တာနက်အား စစ်ဆေးပါ ",
  requestLimit: "တောင်းဆိုမှု အကြိမ်များနေပါသည် .",
  requestPending: "တောင်းဆိုနေသည် ...",
  result_exists: "Result already exists.",
  room_id_required: "Room ID is required.",
  roomClosed: "Room closed.",
  roomClosedNotAllowed: "Room closed not allowed.",
  roomEnded: "Room already ended.",
  roomEndedOrCancelled: "Room ended or cancelled.",
  roomExists: "Not allow to create more than 1 private room.",
  RoomExists: "Not allow to create more than 1 private room.",
  roomFull: "Room is already full.",
  roomIdRequired: "Room ID is required.",
  roomIsPublicFree: "Room is public free.",
  roomLimitLowerMin: "Room limit lower min error occured.",
  roomLimitOverMax: "Room limit over max error occured.",
  roomLimitRequired: "Room limit is required.",
  roomNotExists: "Room not exist.",
  roomOverMax: "Room over max error occured.",
  roomPasswordRequired: "PIN Code is required.",
  roomRateRequired: "Room rate is required.",
  roomTypeRequired: "Room type is required.",
  s_senior_comm_rate_required: "Super Senior commission rate is required.",
  s_senior_id_required: "Super Senior ID is required.",
  secondary_account_exists: "သင်၏ Nickname အား ပြုလုပ်ပြီးပါပြီ ",
  selectLeague: "အနည်းဆုံး လိဒ် ၁ ခု ရွေးချယ်ပါ",
  selectOption: "{fname} အား ရွေးချယ်ပါ ",
  senior_comm_rate_required: "Senior commission rate is required.",
  senior_id_required: "Senior ID is required.",
  session_expired: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  session_not_exists: "အချိန်ကျော်လွန်သွားပါ၍ နောက်တစ်ကြိမ် ထပ်မံဝင်ရောက်ပါ ...",
  sessionTokenRequired: "Session token is required.",
  shareholder_comm_rate_required: "Shareholder commission rate is required.",
  shareholder_id_required: "Shareholder ID is required.",
  slotDisabled: "Slot Disabled",
  sportsTypeRequired: "Sport Type ထည့်သွင်းရန်!",
  startDateRequired: "စတင်သည့်ရက်စွဲ ထည့်သွင်းပါ!",
  SUSPEND: "သင်၏အကောင့်အား ကြည့်ရှုရန်သာ ခွင့်ပြုထားသည် ",
  suspend: "အကောင့်ပိတ်ထားသည် ၊ သင်၏ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  systemError: "အတွင်းစနစ် မှားယွင်းနေသည် ",
  tournamentDisabled: "ကစားပွဲပိတ်ထားသည် ၊ ကျေးဇူးပြု၍ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  tournamentLeagueExists: "ကစားပွဲလိဒ်ရှိနေသည် ၊ ကျေးဇူးပြု၍ အေးဂျင့်အားဆက်သွယ်ပါ ...",
  tournamentMatchExists: "ကစားပွဲပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  transfer_id_required: "Transfer ID ထည့်သွင်းရန်!",
  unableToGetBalanceAtTheMoment: "အတွင်းစနစ် မှားယွင်းနေသည် ",
  usernameRequired: "Username ထည့်ရန် ",
  workingDateRequired: "Working Date ထည့်သွင်းရန်!",
  matchNotStarted: "ကစားပွဲမရှိတော့ပါ ၊ ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
  cashOutUnavailable: "ငွေပေးချေမှုမရှိပါ။",
  errorCashoutAmount: "ငွေပေးချေမှုကို ပြုပြင်နေသည်...",
  invalidParameter: "မှားယွင်းနေသည်။",
  startTimeRequired: "စတင်သည့်ရက်စွဲ ထည့်သွင်းရန်!",
  endTimeRequired: "အဝေးသည့်ရက်စွဲ ထည့်သွင်းရန်!",
  oddsTypeIDRequired: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  commissionRequired: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  requestTimeRequired: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  statusRequired: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidStartTime: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidEndTime: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidOddsTypeID: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidCommission: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidRequestTime: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidStatus: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidAlgoMatchInfo: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidAlgoSliderLeagueInfo: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidAlgoSliderMinutesWeight: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidAlgoSliderBetType: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidRTSRunningScoreDetails: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidProviderGoalTimeLine: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidSliderTimeRange: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidMOMatchOdds: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidProviderSlider: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidCombineBetTypeAndOddsFormat: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  invalidMatchInformation: "စျေးပြင်ဆင်နေသည် ကျေးဇူးပြု၍ ခေတ္တစောင့်ဆိုင်းပါ...",
  marketClose: "ဤဈေးကွက်ပိတ်ထားပါသည်၊ ကျေးဇူးပြု၍ အခြားဈေးကွက်များကို စမ်းကြည့်ပါ။ ",
  error: "အမှား",
  freeRoomNeedBet: "ကျေးဇူးပြု၍ အခြားစျေးကို ရွေးချယ်ပါ.",
};
